import { hexToRgbaColor } from '@hzero-front-ui/core';
import noticeIcon from "./assets/theme1/icons/news.svg";
import workspace from "./assets/theme1/icons/workspace-icon.svg";
import workspaceBlue from "./assets/theme1/icons/workspace-icon-blue.svg";
import headerBg from "./assets/theme1/bg@2x.png";
import theme3Bg from "./assets/theme3/bg.png";
import theme3Workspace from "./assets/theme3/icons/workspace.png";
import theme3WorkspaceBlue from "./assets/theme3/icons/workspace-blue.png";
import theme5Workspace from "./assets/theme5/icons/workspace.png";
import theme5WorkspaceBlue from "./assets/theme5/icons/workspace-blue.png";
var theme1ExtraData = {
  name: 'layout',
  global: true,
  data: [{
    /* 全局设置 */
    selectionFontColor: '#fff',
    collapseTriggerColor: '#fff',
    headerBg: '#4f7de7',
    containerBg: 'rgb(246, 246, 246)',
    bodyContentGap: 8,
    headerHeight: 140,
    // 顶部
    headerBgImage: headerBg,
    headerTitleFontSize: 18,
    headerTitleColor: '#333',
    noticeIcon: noticeIcon,
    workspaceIcon: workspace,
    workspaceActiveIcon: workspaceBlue,
    tabIndent: 8,
    tabBg: 'rgba(255,255,255, .3)',
    tabFontColor: '#fff',
    tabActiveBg: '#fff',
    tabActiveFontColor: '#3b87f5',
    tabHoverBg: 'rgba(255,255,255,0.7)',
    tabHoverFontColor: '#fff',
    workspaceIconOpacity: 0.5,
    workspaceIconHoverOpacity: 0.8,
    workspaceIconActiveOpacity: 1,
    /* 页面布局 */
    headPadding: '0 12px',
    headBg: '#fff',
    headRadius: 2,
    titleFontSize: 14,
    backIconSize: 28,
    contentWrapMargin: '8px 0 0 0',
    contentPadding: 12,
    /* 侧边搜索下拉选择框 */
    searchInputBg: 'rgba(201,201,201,0.2)',
    searchInputBorder: '1px solid transparent',
    searchInputPlaceholderFontColor: '#b1b1b1',
    dropdownItemBg: '#fff',
    dropdownItemFontColor: '#333',
    dropdownItemHoverBg: hexToRgbaColor('#4F7DE7', 0.1),
    dropdownItemFontHoverColor: '#333',
    /* 菜单 */
    menuBg: '#fff',
    collapsedWidth: 42,
    menuNormalWidth: 200,
    menuItemFontColor: '#6a6a6a',
    menuItemActiveFontColor: '#333',
    menuItemActiveBg: hexToRgbaColor('#4f7de7', 0.1),
    menuItemFontSize: 14,
    menuItemRightArrowSize: 6,
    menuItemRightArrowColor: '#333333',
    menuItemHoverFontColor: '#333',
    menuItemHoverBg: hexToRgbaColor('#4f7de7', 0.1),
    subMenuTitleColor: '#333',
    subMenuBg: '#fff',
    subMenuFontColor: '#5A6677',
    subMenuHoverBg: hexToRgbaColor('#4f7de7', 0.1),
    subMenuHoverColor: '#333333',
    leafMenuBg: '#fff',
    leafMenuFontColor: '#5A6677',
    leafMenuHoverBg: hexToRgbaColor('#4f7de7', 0.1),
    leafMenuHoverColor: '#333333',
    dividerLineColor: '#f1f1f1',
    topMenuFontSize: 14,
    topMenuItemRadius: 0,
    topMenuFontColor: '#fff',
    topMenuOpacity: '0.6',
    topMenuActiveFontColor: '#fff',
    topMenuActiveOpacity: '1',
    topMenuBg: 'none',
    topMenuActiveBg: 'none',
    containerBgc: '#F4F5F7',
    menuBgc: '#fff',
    mainMenuFontColor: '#111',
    activeMenuFontColor: '#000',
    menuHeight: 32,
    mainMenuWidth: 188,
    collapsedMainMenuWidth: 42,
    // subMenuFontColor: '#686868',
    activeMenuBgc: '#F2F2F2',
    trMenuLineBgc: '#DBE1F1',
    menuSearchHeight: 28
  }]
};
var theme3ExtraData = {
  name: 'layout',
  global: true,
  data: [{
    /* 全局设置 */
    selectionFontColor: '#fff',
    collapseTriggerColor: '#fff',
    headerBg: '#4f7de7',
    containerBg: 'rgb(246, 246, 246)',
    bodyContentGap: 8,
    headerHeight: 140,
    // 顶部
    headerBgImage: theme3Bg,
    headerTitleFontSize: 18,
    headerTitleColor: '#333',
    noticeIcon: noticeIcon,
    workspaceIcon: theme3Workspace,
    workspaceActiveIcon: theme3WorkspaceBlue,
    tabIndent: 8,
    tabBg: 'rgba(255,255,255, .3)',
    tabFontColor: '#fff',
    tabActiveBg: '#fff',
    tabActiveFontColor: '#3b87f5',
    tabHoverBg: 'rgba(255,255,255,0.7)',
    tabHoverFontColor: '#fff',
    workspaceIconOpacity: 0.5,
    workspaceIconHoverOpacity: 0.8,
    workspaceIconActiveOpacity: 1,
    /* 页面布局 */
    headPadding: '0 12px',
    headBg: '#fff',
    headRadius: 2,
    titleFontSize: 14,
    backIconSize: 28,
    contentWrapMargin: '8px 0 0 0',
    contentPadding: 12,
    /* 侧边搜索下拉选择框 */
    searchInputBg: 'rgba(201,201,201,0.2)',
    searchInputBorder: '1px solid transparent',
    searchInputPlaceholderFontColor: '#b1b1b1',
    dropdownItemBg: '#fff',
    dropdownItemFontColor: '#333',
    dropdownItemHoverBg: hexToRgbaColor('#4F7DE7', 0.1),
    dropdownItemFontHoverColor: '#333',
    /* 菜单 */
    menuBg: '#fff',
    collapsedWidth: 42,
    menuNormalWidth: 200,
    menuItemFontColor: '#6a6a6a',
    menuItemActiveFontColor: '#333',
    menuItemActiveBg: hexToRgbaColor('#4f7de7', 0.1),
    menuItemFontSize: 14,
    menuItemRightArrowSize: 6,
    menuItemRightArrowColor: '#333333',
    menuItemHoverFontColor: '#333',
    menuItemHoverBg: hexToRgbaColor('#4f7de7', 0.1),
    subMenuTitleColor: '#333',
    subMenuBg: '#fff',
    subMenuFontColor: '#5A6677',
    subMenuHoverBg: hexToRgbaColor('#4f7de7', 0.1),
    subMenuHoverColor: '#333333',
    leafMenuBg: '#fff',
    leafMenuFontColor: '#5A6677',
    leafMenuHoverBg: hexToRgbaColor('#4f7de7', 0.1),
    leafMenuHoverColor: '#333333',
    dividerLineColor: '#f1f1f1',
    topMenuFontSize: 14,
    topMenuItemRadius: 0,
    topMenuFontColor: '#fff',
    topMenuOpacity: '0.6',
    topMenuActiveFontColor: '#fff',
    topMenuActiveOpacity: '1',
    topMenuBg: 'none',
    topMenuActiveBg: 'none',
    containerBgc: '#F4F5F7',
    menuBgc: '#fff',
    mainMenuFontColor: '#111',
    activeMenuFontColor: '#000',
    menuHeight: 32,
    mainMenuWidth: 188,
    collapsedMainMenuWidth: 42,
    // subMenuFontColor: '#686868',
    activeMenuBgc: '#F2F2F2',
    trMenuLineBgc: '#DBE1F1',
    menuSearchHeight: 28
  }]
};
var theme5ExtraData = {
  name: 'layout',
  global: true,
  data: [{
    /* 全局设置 */
    containerBgc: '#F4F5F7',
    menuBgc: '#fff',
    mainMenuFontColor: '#111',
    activeMenuFontColor: '#000',
    menuHeight: 32,
    mainMenuWidth: 188,
    collapsedMainMenuWidth: 42,
    subMenuFontColor: '#686868',
    activeMenuBgc: '#F2F2F2',
    trMenuLineBgc: '#DBE1F1',
    menuSearchHeight: 28,
    selectionFontColor: '#fff',
    collapseTriggerColor: '#fff',
    headerBg: '#0840F8',
    containerBg: 'rgb(245, 245, 245)',
    bodyContentGap: 8,
    headerHeight: 148,
    // 顶部
    headerTitleFontSize: 18,
    headerTitleColor: '#333',
    noticeIcon: noticeIcon,
    workspaceIcon: theme5Workspace,
    workspaceActiveIcon: theme5WorkspaceBlue,
    tabIndent: 8,
    tabBg: 'rgba(255,255,255, .3)',
    tabFontColor: '#fff',
    tabFontBgColor: '#DCE6FE',
    tabActiveBg: '#fff',
    tabActiveFontColor: '#3b87f5',
    tabHoverBg: 'rgba(255,255,255,0.7)',
    tabHoverFontColor: '#fff',
    workspaceIconOpacity: 0.5,
    workspaceIconHoverOpacity: 0.8,
    workspaceIconActiveOpacity: 1,
    /* 页面布局 */
    headPadding: '0 12px',
    headBg: '#fff',
    headRadius: 2,
    titleFontSize: 14,
    backIconSize: 28,
    contentWrapMargin: '8px 0 0 0',
    contentPadding: 12,
    /* 侧边搜索下拉选择框 */
    searchInputBg: 'rgba(201,201,201,0.2)',
    searchInputBorder: '1px solid transparent',
    searchInputPlaceholderFontColor: '#b1b1b1',
    dropdownItemBg: '#fff',
    dropdownItemFontColor: '#333',
    dropdownItemHoverBg: hexToRgbaColor('#0840F8', 0.1),
    dropdownItemFontHoverColor: '#333',
    /* 菜单 */
    menuBg: '#fff',
    collapsedWidth: 42,
    menuNormalWidth: 188,
    menuItemFontColor: '#6a6a6a',
    menuItemActiveFontColor: '#333',
    menuItemActiveBg: hexToRgbaColor('#0840F8', 0.1),
    menuItemFontSize: 14,
    menuItemRightArrowSize: 6,
    menuItemRightArrowColor: '#333333',
    menuItemHoverFontColor: '#333',
    menuItemHoverBg: hexToRgbaColor('#0840F8', 0.1),
    subMenuTitleColor: '#333',
    subMenuBg: '#fff',
    // subMenuFontColor: '#5A6677',
    subMenuHoverBg: hexToRgbaColor('#0840F8', 0.1),
    subMenuHoverColor: '#333333',
    leafMenuBg: '#fff',
    leafMenuFontColor: '#5A6677',
    leafMenuHoverBg: hexToRgbaColor('#0840F8', 0.1),
    leafMenuHoverColor: '#333333',
    dividerLineColor: '#f1f1f1',
    topMenuFontSize: 14,
    topMenuItemRadius: 0,
    topMenuFontColor: '#fff',
    topMenuOpacity: '0.6',
    topMenuActiveFontColor: '#fff',
    topMenuActiveOpacity: '1',
    topMenuBg: 'none',
    topMenuActiveBg: 'none' // leftSideCalloutLayout样式变量
    // leftSideCalloutLayoutHeaderHeight: 50, // 布局头部高度
    // leftSideCalloutLayoutMenuWidth: 188, // 菜单宽度
    // // hzeroLayoutNavHeight: 34px, // menuTab高度
    // // hzeroLayoutPrefixPageHeaderHeight: 44px, // Page/Header 高度
    // leftSideCalloutLayoutMenuLogoLeft: 20, // logo距离左边宽度
    // leftSideCalloutLayoutMenuLogoSize: 20, // logo大小
    // leftSideCalloutLayoutMainMenuHeight: 32, // 一级菜单高度
    // leftSideCalloutLayoutMainMenuFontSize: 14, // 一级菜单字体大小
    // leftSideCalloutLayoutMainMenuRight: 20, // 一级菜单距离左右边宽度
    // leftSideCalloutLayoutMainMenuRightIconWidth: 6, // 三角形的宽度
    // leftSideCalloutLayoutMainMenuRightIconHeight: 4, // 三角形的高
    // leftSideCalloutLayoutSubMenuWidth: 168, // 二级菜单宽度
    // leftSideCalloutLayoutSubMenuHeight: 36,
  }]
};

export { theme1ExtraData, theme3ExtraData, theme5ExtraData };
export default theme1ExtraData;